import { FormEvent, useEffect, useState } from 'react';
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  ModalBody,
  ModalFooter,
  Switch,
} from '@chakra-ui/react';

import { ModalComponent } from '..';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string, isPublic: boolean) => Promise<void>;
}

export function ModalAddNewBookmarkBI({ isOpen, onClose, onSave }: Props) {
  const [name, setName] = useState('');
  const [isPublic, setIsPublic] = useState(false);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setName('');
      setIsPublic(false);
      setError('');
    }
  }, [isOpen]);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();

    if (!name.trim()) {
      setError('Dê um nome para a visualização.');
      return;
    }

    setSaving(true);
    try {
      await onSave(name.trim(), isPublic);
      onClose();
    } catch {
      // Quem chamou já mostrou o aviso de erro; o modal continua aberto.
    } finally {
      setSaving(false);
    }
  };

  return (
    <ModalComponent title="Nova visualização" isOpen={isOpen} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <FormControl isInvalid={!!error} mb="5">
            <FormLabel htmlFor="bookmark-name">
              Como deseja chamar esta visualização?
            </FormLabel>
            <Input
              id="bookmark-name"
              value={name}
              onChange={event => {
                setName(event.target.value);
                setError('');
              }}
              placeholder="Ex: Fechamento de lote suicoper"
              maxLength={120}
              autoFocus
            />
            <FormErrorMessage>{error}</FormErrorMessage>
          </FormControl>

          <FormControl display="flex" alignItems="center">
            <FormLabel htmlFor="bookmark-public" mb="0">
              Tornar visualização pública?
            </FormLabel>
            <Switch
              id="bookmark-public"
              isChecked={isPublic}
              onChange={event => setIsPublic(event.target.checked)}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Fechar
          </Button>
          <Button colorScheme="blue" type="submit" isLoading={saving}>
            Salvar
          </Button>
        </ModalFooter>
      </form>
    </ModalComponent>
  );
}
